module.exports = __webpack_public_path__ + "img/sunich-rgb.753f598.png";